import type {
  PropertyAvailableName,
  PropertyStringType,
  PropertyArrayType,
} from "@constructor/shared-entity";
import type {
  PageDataPropList,
  PageDataPropSimple,
  PageDataPropUnion,
} from "@constructor/shared-entity/type";

function getValueForProp(
  name: keyof typeof PropertyStringType,
  list: PageDataPropUnion[]
): string | null;
function getValueForProp(
  name: keyof typeof PropertyArrayType,
  list: PageDataPropUnion[]
): string[] | null;
function getValueForProp(
  name: keyof typeof PropertyAvailableName,
  list: PageDataPropUnion[]
): string | string[] | null {
  const prop = list.find((el) => el.name === name);
  if (prop?.kind === "simple") {
    return (prop as PageDataPropSimple).value;
  } else if (prop?.kind === "list") {
    return (prop as PageDataPropList).valueList;
  }

  return null;
}

export default getValueForProp;
